/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Region_Middle_East_DescriptionInputs */

const bn_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ঘন সীমানা এবং শক্তিশালী আঞ্চলিক মিল।`)
};

const de_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichte Grenzen und starke regionale Ähnlichkeit.`)
};

const el_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πυκνά σύνορα και έντονη περιφερειακή ομοιότητα.`)
};

const en_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dense borders and strong regional similarity.`)
};

const es_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fronteras densas y fuerte similitud regional.`)
};

const fr_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frontières denses et forte similarité régionale.`)
};

const hi_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सघन सीमाएँ और मजबूत क्षेत्रीय समानता।`)
};

const hu_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sűrű határok és erős regionális hasonlóság.`)
};

const id_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perbatasan yang padat dan kesamaan regional yang kuat.`)
};

const it_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confini fitti e forte somiglianza regionale.`)
};

const ja_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`密集した国境と強い地域的類似性。`)
};

const ko_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`국경이 촘촘하고 지역적 유사성이 강합니다.`)
};

const nl_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichte grenzen en sterke regionale gelijkenis.`)
};

const pl_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gęste granice i silne podobieństwo regionalne.`)
};

const pt_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fronteiras densas e forte semelhança regional.`)
};

const ru_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Плотные границы и сильное региональное сходство.`)
};

const sv_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täta gränser och stark regional likhet.`)
};

const tr_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yoğun sınırlar ve güçlü bölgesel benzerlikler.`)
};

const uk_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Щільні кордони та сильна регіональна подібність.`)
};

const vi_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biên giới dày đặc và sự tương đồng mạnh mẽ trong khu vực.`)
};

const zh_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`边界密集，区域相似性强。`)
};

const zh_hant_intro_region_middle_east_description = /** @type {(inputs: Intro_Region_Middle_East_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`邊界密集，區域相似性強。`)
};

/**
* | output |
* | --- |
* | "Dense borders and strong regional similarity." |
*
* @param {Intro_Region_Middle_East_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_region_middle_east_description = /** @type {((inputs?: Intro_Region_Middle_East_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Region_Middle_East_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_region_middle_east_description(inputs)
	if (locale === "de") return de_intro_region_middle_east_description(inputs)
	if (locale === "el") return el_intro_region_middle_east_description(inputs)
	if (locale === "en") return en_intro_region_middle_east_description(inputs)
	if (locale === "es") return es_intro_region_middle_east_description(inputs)
	if (locale === "fr") return fr_intro_region_middle_east_description(inputs)
	if (locale === "hi") return hi_intro_region_middle_east_description(inputs)
	if (locale === "hu") return hu_intro_region_middle_east_description(inputs)
	if (locale === "id") return id_intro_region_middle_east_description(inputs)
	if (locale === "it") return it_intro_region_middle_east_description(inputs)
	if (locale === "ja") return ja_intro_region_middle_east_description(inputs)
	if (locale === "ko") return ko_intro_region_middle_east_description(inputs)
	if (locale === "nl") return nl_intro_region_middle_east_description(inputs)
	if (locale === "pl") return pl_intro_region_middle_east_description(inputs)
	if (locale === "pt") return pt_intro_region_middle_east_description(inputs)
	if (locale === "ru") return ru_intro_region_middle_east_description(inputs)
	if (locale === "sv") return sv_intro_region_middle_east_description(inputs)
	if (locale === "tr") return tr_intro_region_middle_east_description(inputs)
	if (locale === "uk") return uk_intro_region_middle_east_description(inputs)
	if (locale === "vi") return vi_intro_region_middle_east_description(inputs)
	if (locale === "zh") return zh_intro_region_middle_east_description(inputs)
	return zh_hant_intro_region_middle_east_description(inputs)
});